import React, { useEffect, useRef, useState } from "react";
import './uploadpage.css'
import { getAllVendors, setJsonData } from "../../../store/Admin/upload/upload.actions";
import { useDispatch, useSelector } from "react-redux";
import PreviewPage from '../preview/PreviewPage'
import close from '../../../assets/Admin/close.svg'
import excelIcon from '../../../assets/Admin/excel-icon.svg'
import StateSelectors from "../../../utils/Admin/constants/selector.constants";
import CModal from "../../../components/Admin/custom-modal/CModal";
import { ApiPaths } from "../../../utils/Admin/constants/api-path.constants";
import { hideLoader, showLoader } from "../../../store/Admin/Loader/loader.slice";

const UploadPage = () => {

  const dispatch = useDispatch()
  const chooseInputRef = useRef()
  const uploadState = useSelector(StateSelectors.UPLOAD_SELECTOR)
  const modalRef = useRef()

  const [fieldValues, setFieldValues] = useState({
    distributor: '',
    fileType: '',
    file: null,
    APIUrl: '',
    fileName: '',
    fullFileName: ''
  })

  const [fileError, setFileError] = useState('')
  const [enablePreview, setEnablePreview] = useState(false)
  const [file, setFile] = useState(null)

  useEffect(() => {

    if (uploadState.isUploading === false) {
      dispatch(hideLoader())
    }

    if(uploadState.isUploading === true && enablePreview === true){
      dispatch(showLoader('Uploading file data to database...'))
    }

    if (uploadState.isLoading === true) {
      dispatch(showLoader('Getting distributors list...'))
    }

  }, [uploadState])

  useEffect(() => {
    dispatch(getAllVendors())
  }, [])


  const resetFile = () => {
    setFieldValues({
      ...fieldValues,
      file: null,
      fileName: '',
      fullFileName: ''
    })
    setFile(null)
    setFileError('')
    chooseInputRef.current.value = null
  }

  const handleDropdownChange = (ev, label) => {
    resetFile()
    setFile(null)
    
    if (label === 'distributor') {
      setFieldValues({
        distributor: ev.target.innerText,
        fileType: '',
        file: null,
        APIUrl: '',
        fileName: '',
        fullFileName: ''
      })
      return
    }

    if (ev.target.innerText === 'API') {
      setFieldValues({ ...fieldValues, [label]: ev.target.innerText, APIUrl: '' })
      modalRef.current.showModalContent('warning', 'No API available for the selected vendor. Please select different upload type.', true)
    } else {

      setFileError('')
      chooseInputRef.current.value = null
      if (ev.target.innerText === 'Excel' || ev.target.innerText === 'CSV') {
        setFieldValues({
          ...fieldValues,
          [label]: ev.target.innerText,
          APIUrl: '',
          file: null,
          fileName: '',
          fullFileName: ''
        })
      } else if (fieldValues.fileType === 'API' && ev.target.innerText !== 'API') {
        setFieldValues({
          ...fieldValues,
          [label]: ev.target.innerText,
          // APIUrl: 'https://vendorname/api/mis/reports',
          APIUrl: '',
          file: null,
          fileName: '',
          fullFileName: ''
        })
      } else if (fieldValues.fileType !== 'API' && ev.target.innerText !== 'API') {
        setFieldValues({
          ...fieldValues,
          [label]: ev.target.innerText,
          APIUrl: '',
          file: null,
          fileName: '',
          fullFileName: ''
        })
      }

    }
  }
  
  //console.log(fieldValues);
  const onChooseFile = async(ev) => {
    let raw = ev.target.files[0]
    resetFile()
    setFile(raw)
    setFileError('')
    /** get extension */
    let nameRegEx = /^[a-zA-Z0-9_-\s]+$/
    let fileName = raw.name.split('.')
    let ext = raw.name.substring(raw.name.lastIndexOf('.') + 1)
    let nameArr = raw.name.split('.' + ext)
    //console.log(raw.name, ext, nameArr[0],  nameArr[0].match(nameRegEx));
    /** validations */
    if (raw.size > 52428800) {
      setFileError('<p>Maximum uploadable file size is 50MB</p>')
    } else if ( fieldValues.fileType === 'Excel' && ext.toLowerCase() !== 'xlsx') {
      setFileError('<p>Incorrect file type selection</p>')
    } else if ( fieldValues.fileType === 'CSV' && ext.toLowerCase() !== 'csv') {
      setFileError('<p>Incorrect file type selection</p>')
    } else if ( !nameArr[0].match(nameRegEx)) {
      setFileError('<p>Invalid filename. Only A-z 0-9 _ - accepted</p>')
    } else {
      setFieldValues({ ...fieldValues, file: raw, fileName: fileName[0], fullFileName: raw.name })
    }   
  }

  const resetFields = () => {
    setFieldValues({
      ...fieldValues,
      file: null,
      APIUrl: '',
      fileName: ''
    })
    setFileError('')
    setFile(null)
    chooseInputRef.current.value = null
  }

  const togglePreviewMode = (bool) => {
    if (bool === false) {
      modalRef.current.showModalContent('failure', 'Chosen file is empty / invalid. Please upload a new one.', true)
      resetFile()
    } else {
      setEnablePreview(bool)
    }
  }

  const onUploadFormSubmit = (ev) => {
    ev.preventDefault()
    /** show warning popup for the vendors who don't have API or not configured  */
    if (typeof ApiPaths.Upload[fieldValues.distributor?.toLowerCase()] === 'undefined') {
      modalRef.current.showModalContent('failure', 'API is not configured for the selected distributor', true)
      return
    }

    if (fieldValues.fileType !== 'API') {
      dispatch(showLoader('Reading chosen file...'))
      let extension = fieldValues.fullFileName.split('.').pop()
      let fileName = fieldValues.fullFileName.split('.')
      dispatch(setJsonData(file, fileName[0], extension, fieldValues.distributor, togglePreviewMode))
    } else {
      modalRef.current.showModalContent('warning', 'No API available for the selected vendor. Please select different file upload type.', true)
    }
  }

  const handleChooseClick = () => {
    chooseInputRef.current.click()
  }

  const backToUploads = (isResetAll) => {
    setEnablePreview(false)
    if (isResetAll === true) {
      setFieldValues({
        distributor: '',
        fileType: '',
        file: null,
        APIUrl: '',
        fileName: '',
        fullFileName: ''
      })
      setFileError('')
      setFile(null)
      chooseInputRef.current.value = null
    } else {
      resetFields()
    }
  }

  return <section className="upload-section bg-custom-grey h-100">
    <div className="pt-4 px-3" hidden={enablePreview}>
      <div className="mx-1 mx-xl-5 upload-section-content-wrapper bg-white">

      <h3 className="px-4 upload-section-header py-4 bg-white">Upload MIS Information</h3>
      <form className="row no-row-margin px-4 pb-4 pt-3 bg-white align-items-end" onSubmit={onUploadFormSubmit}>
        <div className="col-6 ps-0 pe-4 upload-form-item">
          <label htmlFor="distributor" className="text-capitalize cl-custom-grey">Select distributor</label>
          <div className="dropdown distributor-dropdown col-6 w-100 mt-1">
            <button className="btn no-shadow dropdown-toggle w-100 text-start dropdown-icon-shape dropdown-button-padding" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
              { fieldValues.distributor.length ? fieldValues.distributor : 'please select' }
            </button>
            <ul className="dropdown-menu maxHeight14-scroll w-100 background-white" aria-labelledby="dropdownMenuButton1">
              {
                uploadState.vendorNames.map(vObj => (<li onClick={(e) => handleDropdownChange(e, 'distributor')} className="text-capitalize cursor-pointer bg-white">{ vObj.broker_name?.toLowerCase() }</li>))
              }
            </ul>
          </div>
        </div>
        <div className="col-6 ps-4 pe-2 upload-form-item">
          <label htmlFor="type" className="text-capitalize cl-custom-grey">upload type</label>
          <div className="dropdown file-type-dropdown col-6 w-100 mt-1">
            <button className="btn no-shadow dropdown-toggle w-100 text-start dropdown-icon-shape dropdown-button-padding" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
              { fieldValues.fileType.length ? fieldValues.fileType : 'please select' }
            </button>
            <ul className="dropdown-menu w-100 background-white" aria-labelledby="dropdownMenuButton1">
              <li onClick={(e) => handleDropdownChange(e,'fileType')}  className="text-capitalize cursor-pointer bg-white">Excel</li>
              <li onClick={(e) => handleDropdownChange(e,'fileType')} className="text-capitalize cursor-pointer bg-white">CSV</li>
              <li onClick={(e) => handleDropdownChange(e,'fileType')} className="text-capitalize cursor-pointer bg-white">API</li>
            </ul>
          </div>
        </div>

        <div hidden={fieldValues.distributor.length === 0 || fieldValues.fileType.length === 0} className={fieldValues.fileType === 'API' ? "col-12  mt-2 ps-0 upload-form-item mt-4 pe-2" : "col-6 pe-4 ps-0 mt-2 upload-form-item mt-4"}>
          <label htmlFor="type" className="text-capitalize cl-custom-grey w-100">
            {fieldValues.fileType === 'API' ? 'API URL' : 'choose file'}
          </label>
          <div className={fieldValues.fileType === 'API' ? "d-none" : "d-flex align-items-center input-box"} onClick={handleChooseClick}>
            <button type="button" className="bg-custom-grey py-2 px-3 text-capitalize choose-btn">choose...</button>
            <p className="mb-0 cl-custom-grey ps-3 fs-sm">{ fieldValues.fileName }</p>
            <input accept=".csv,.xlsx" ref={chooseInputRef} onChange={onChooseFile} className="upload-file-input w-100 py-1 d-none" type="file" />
          </div>
            <input disabled hidden={fieldValues.fileType !== 'API'} type="text" className="input-box py-2 w-100 pe-0 ps-3" value={fieldValues.APIUrl} />
          <p className="mt-1 mb-0 error-text-container" dangerouslySetInnerHTML={{__html : fileError}} />
        </div>
        
        <div hidden={fieldValues.distributor.length === 0 || fieldValues.fileType.length === 0} className={ fieldValues.fileType === 'API' || fieldValues.fileName.length === 0 ? "d-none" : "col-6 mt-4 ps-4 pe-2 ps-3 position-relative"}>
          
            <img src={excelIcon} width="18" height="18" alt="reset" onClick={resetFile} className="mb-0 cursor-pointer position-absolute doc-ext-icon cl-custom-grey" />
            <p className="mb-0 cl-custom-grey input-box ps-5 fs-md mb-1 py-2">{fieldValues.fileName}</p>
            <img src={close} width="13" height="13" alt="reset" onClick={resetFile} className="mb-0 cursor-pointer position-absolute remove-doc cl-custom-grey" />
        </div>

        <div className="col-12 mt-4 text-center">
          <button disabled={fieldValues.APIUrl.length === 0 && fieldValues.file === null} type="submit" className="w-25 form-upload-btn mt-4 text-capitalize disabled-custom text-white px-3 py-2 py-lg-3 py-xl-3  no-shadow">preview & save</button>
        </div>
      </form>
      </div>
    </div>

    <div className="pt-4 px-3" hidden={!enablePreview}>
      <PreviewPage backToUploads={backToUploads} fieldValues={ fieldValues }/>
    </div>
    <CModal ref={modalRef} />
  </section>
};

export default UploadPage;
